module.exports = __webpack_public_path__ + "img/fondoCAS1.0dcdb62d.png";